import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { Bell, ChatCircle, CalendarCheck } from "@phosphor-icons/react";

export const NotificationBell = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({ total: 0, items: [], unread_messages: 0 });
  const prevTotal = useRef(0);

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setData(data);
      if (data.total > prevTotal.current && prevTotal.current !== 0) {
        toast.info("Vous avez une nouvelle notification");
      }
      prevTotal.current = data.total;
    } catch { /* not logged in */ }
  };

  useEffect(() => { load(); const t = setInterval(load, 4000); return () => clearInterval(t); }, []);

  const markRead = async () => { await api.post("/notifications/read"); load(); };

  return (
    <DropdownMenu onOpenChange={(o) => o && markRead()}>
      <DropdownMenuTrigger asChild>
        <Button data-testid="notif-bell" variant="ghost" size="icon" className="relative text-stone-700 hover:text-orange-800">
          <Bell size={22} weight={data.total > 0 ? "fill" : "regular"} />
          {data.total > 0 && (
            <span data-testid="notif-badge" className="absolute -top-0.5 -right-0.5 bg-orange-800 text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 px-1 grid place-items-center">
              {data.total > 9 ? "9+" : data.total}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 p-0 bg-white">
        <div className="p-3 border-b border-stone-100 font-display font-bold text-stone-900">Notifications</div>
        <div className="max-h-80 overflow-y-auto">
          {data.unread_messages > 0 && (
            <button onClick={() => navigate("/messages")} className="w-full flex items-center gap-3 p-3 hover:bg-stone-50 text-left border-b border-stone-50">
              <span className="w-9 h-9 rounded-lg bg-orange-50 text-orange-800 grid place-items-center"><ChatCircle weight="fill" size={18} /></span>
              <span className="text-sm text-stone-700">{data.unread_messages} message(s) non lu(s)</span>
            </button>
          )}
          {data.items?.length === 0 && data.unread_messages === 0 ? (
            <div className="p-6 text-center text-stone-400 text-sm">Aucune notification</div>
          ) : (
            data.items?.map((n) => (
              <div key={n.id} className={`flex items-center gap-3 p-3 border-b border-stone-50 ${!n.read ? "bg-orange-50/40" : ""}`}>
                <span className="w-9 h-9 rounded-lg bg-stone-100 text-stone-600 grid place-items-center">
                  {n.type === "booking" ? <CalendarCheck weight="fill" size={18} /> : <ChatCircle weight="fill" size={18} />}
                </span>
                <span className="text-sm text-stone-700">{n.text}</span>
              </div>
            ))
          )}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
